import useLabels from "hooks/useLabels";
import { TOTAL_PAPER_FIELD_COUNT } from "../StudySnapshot";

function StudySnapshotLoading() {
  const [studySnapshotLabels] = useLabels("study-snapshot");

  return (
    <div
      data-testid="study-snapshot-result-loading"
      className="flex flex-col items-center justify-center w-full gap-2 py-4"
    >
      <p className="flex gap-2 stagger-animation">
        <span className="inline-block w-4 h-3 rounded-full bg-bg-subtle animate-pulse"></span>
        <span className="inline-block w-16 h-3 rounded-full bg-bg-subtle animate-pulse"></span>
        <span className="inline-block w-4 h-3 rounded-full bg-bg-subtle animate-pulse"></span>
        <span className="inline-block w-16 h-3 rounded-full bg-bg-subtle animate-pulse"></span>
        <span className="inline-block w-4 h-3 rounded-full bg-bg-subtle animate-pulse"></span>
        <span className="inline-block w-16 h-3 rounded-full bg-bg-subtle animate-pulse"></span>
      </p>
      <p className="tiny-normal text-fg-muted">
        {studySnapshotLabels["loading-text"].replace(
          "{n}",
          TOTAL_PAPER_FIELD_COUNT
        )}
      </p>
    </div>
  );
}

export default StudySnapshotLoading;
